import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { RequiredAnalyticalFeaturesInterface } from '@zaoblako/shared/modules/catalog/dtos/required-analytical-features.dto';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SettingsService {
  public constructor(private readonly http: HttpClient) {}

  public getRequiredAnalyticalFeatures(): Observable<RequiredAnalyticalFeaturesInterface> {
    return this.http.get<RequiredAnalyticalFeaturesInterface>('/dashboard/required-analytical-features');
  }

  public updateRequiredAnalyticalFeatures(features: RequiredAnalyticalFeaturesInterface): Observable<void> {
    return this.http.put<void>('/dashboard/required-analytical-features', features);
  }
}
